// @flow

import React from "react";

import type { UsersAndGroups, UID } from "src/types";
import { transformUserNotification } from "src/utils/checklist";

import { FieldValue } from "../Values/styles";
import UsersValue from "./UsersValue";
import UserDiffValue from "./UserDiffValue";

type Props = {
  newValue: Array<UsersAndGroups | UID>,
  oldValue: Array<UsersAndGroups | UID>,
};

const Users = ({ newValue, oldValue }: Props) => {
  const transformedNewValues = (newValue || []).map(transformUserNotification);
  const transformedOldValues = (oldValue || []).map(transformUserNotification);
  return (
    <>
      <FieldValue old>
        <UserDiffValue
          newValue={transformedOldValues}
          oldValue={transformedNewValues}
        />
      </FieldValue>
      <UsersValue values={transformedNewValues} />
    </>
  );
};

export default Users;
